// A festival film's stills, made in the entrant's own browser before it goes up (components/ui/FestivalDrawer.jsx): how
// long it runs, a sheet of twelve frames in the order they play (four across, lib/festival.js SHEET), which is how Pino
// watches it, and one frame for its poster. Nothing is cut or rendered on a server (Sam, 24 Oct: "don't render it on
// the server"), and Sam sees the film itself beside the sheet before it goes in.

import { SHEET } from './festival.js'

const once = (el, ok, bad = 'error') => new Promise((resolve, reject) => {
  const done = () => { el.removeEventListener(ok, done); el.removeEventListener(bad, fail); resolve() }
  const fail = () => { el.removeEventListener(ok, done); el.removeEventListener(bad, fail); reject(new Error("Your browser can't read this file. Try an mp4 (H.264).")) }
  el.addEventListener(ok, done)
  el.addEventListener(bad, fail)
})

async function seek(v, t) {
  const at = once(v, 'seeked')
  v.currentTime = Math.max(0, Math.min(v.duration - 0.05, t))
  await at
}

// a frame into a box, whole and centred on black, whatever its shape
function drawInto(ctx, v, x, y, w, h) {
  const vw = v.videoWidth || w, vh = v.videoHeight || h
  const k = Math.min(w / vw, h / vh)
  const dw = vw * k, dh = vh * k
  ctx.fillStyle = '#000'
  ctx.fillRect(x, y, w, h)
  ctx.drawImage(v, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh)
}

const blobOf = (canvas, type, q) => new Promise((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Could not make the stills.'))), type, q))

/** { seconds, sheet: Blob (png), poster: Blob (jpeg) } for a video File. */
export async function stillsOf(file) {
  const url = URL.createObjectURL(file)
  const v = document.createElement('video')
  v.muted = true
  v.playsInline = true
  v.preload = 'auto'
  try {
    const meta = once(v, 'loadeddata')
    v.src = url
    await meta
    const seconds = v.duration
    if (!Number.isFinite(seconds) || seconds <= 0) throw new Error("Couldn't tell how long it runs. Try an mp4 (H.264).")
    const { cols, rows, w, h } = SHEET
    const sheet = document.createElement('canvas')
    sheet.width = cols * w
    sheet.height = rows * h
    const sc = sheet.getContext('2d')
    const n = cols * rows
    for (let i = 0; i < n; i++) {
      await seek(v, (seconds * (i + 0.5)) / n)
      drawInto(sc, v, (i % cols) * w, Math.floor(i / cols) * h, w, h)
    }
    const poster = document.createElement('canvas')
    poster.width = 640
    poster.height = 360
    await seek(v, seconds * 0.25)
    drawInto(poster.getContext('2d'), v, 0, 0, 640, 360)
    return { seconds, sheet: await blobOf(sheet, 'image/png'), poster: await blobOf(poster, 'image/jpeg', 0.86) }
  } finally {
    v.removeAttribute('src')
    URL.revokeObjectURL(url)
  }
}
